import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get, Jiffy } from "@green24/npm-javascript-utils";
import Interpret from "../../../components/shared/Localization/Interpret";
import withStorageUnit from "../../../components/shared/hoc/withStorageUnit";
import { StorageUtils } from "../../../utils/StorageUtils";
import { Price } from "../../../components/components";
import { sessionServices } from "../../../services/session-services";
import { route } from "preact-router";
import MessageModal from "../../../components/shared/Modal/MessageModal";
import { ErrorUtils } from "../../../utils/ErrorUtils";
import { AppUtils } from "../../../utils/AppUtils";
import { E_BoxRoute_Action, E_Route } from "../../../models/constants/Enum_Routes";
import { E_Box_OpenMode } from "../../../models/constants/Enums_Storage";
import PaymentTerminal from "../../../components/shared/PaymentTerminal";
import { E_Payment_Mode } from "../../../models/constants/Enums_Payment";
import Loading from "../../../components/shared/Loading";

class RentWizardPayment extends Component {
	constructor() {
		super();

		this.state = {
			opening: false,
		}
	}

	render(
		{className, style, unit, serviceTypeID, bracketID, session, onSession},
		{opening}
	) {
		const serviceType = StorageUtils.findServiceTypeFromUnitByID(unit, serviceTypeID);
		if(!serviceType) return null;

		const bracket = StorageUtils.getTimeBracketByID(serviceType.tariff.timeBrackets, bracketID);
		if(!bracket) return null;

		return (
			<section className={combineClasses("rent-wizard-payment", className)} style={style}>
				<PaymentTerminal
					title={"payment.title"}
					contentHeaderLeftSlot={
						<div className={"selected-service-type"}>
							<div><Interpret id={serviceType.titles}/></div>
							<div>{get(session, "service.physicalReference")}</div>
						</div>
					}
					contentHeaderSlot={
						<div className={"selected-time-bracket"}>
							<Interpret
								id={"timeBracketUpToTime"}
								params={{
									price: <b><Price value={bracket.price}/></b>,
									time: <b>{Jiffy.readableDuration(bracket.maxMinutes * 60000)}</b>,
								}}
							/>
						</div>
					}
					idleContentSlot={
						<>
							<h2><Interpret id={"session.penalty.warning.title"}/></h2>

							<p><Interpret id={"session.penalty.warning.message"}/></p>

							<p className={"addendum"}><Interpret id={"termsAgreeNotice"}/></p>
						</>
					}

					paymentMode={E_Payment_Mode.INITIAL_PAYMENT}
					sessionID={parseInt(session.id)}
					session={session}
					onSession={onSession}
					onPaid={() => this._openBox()}
				/>

				{opening && <Loading title={"box.open.pending"} className={"with-background"}/>}
			</section>
		);
	}

	_openBox() {
		const {session} = this.props;

		this.setState({opening: true});
		sessionServices.openBoxByPin(
			session.pin,
			E_Box_OpenMode.OPEN_DELAYED,
			AppUtils.simulateBoxOpening
		).then(data => {
			route(E_Route.BOX_OPENING(E_BoxRoute_Action.FIRST_OPENING, {
				timeout: data.openDelaySeconds,
				physicalReference: get(data.session, "service.physicalReference"),
			}));
		}, (res) => {
			this.setState({opening: false});

			let error = ErrorUtils.getErrorFromResponse(res);

			//TBD: More specific error?
			window.modal.open(
				<MessageModal
					icon={error.icon}
					title={error.title}
					titleTranslated={error.titleTranslated}
					message={"box.open.error.message"}
					actionButtons={() => [
						{
							className: "close",
							text: "support.contact",
							href: E_Route.HELP,
							action: () => window.modal.close(),
						},
						{
							className: "confirm",
							text: "retry",
							action: () => {
								window.modal.close();

								this._openBox();
							},
						},
					]}
				/>,
				{
					accent: "error",
				},
			);
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			serviceTypeID: PropTypes.number,
			bracketID: PropTypes.number,

			session: PropTypes.object,

			//withStorageUnit
			unit: PropTypes.object,

			onSession: PropTypes.func.isRequired,
		}
	}

	static get stateTypes() {
		return {
			opening: PropTypes.bool,
		}
	}
}

export default withStorageUnit(RentWizardPayment);
